export default "__VITE_ASSET__L9Qhjy8F__"